const template = import.meta.env.VITE_TEMPLATE;
if (template === "room") {
  import("./main.app.room");
} else if (template === "arada") {
  import("./main.app.arada");
} else {
  import("./main.app.room");
}